"use client";
import {
  useCompositeSeparator
} from "../__chunks/WEEEI3KU.js";
import "../__chunks/LOI6GHIP.js";
import {
  useToolbarContext
} from "../__chunks/IIER4YBF.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/HKOOKEDE.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/toolbar/toolbar-separator.tsx
var TagName = "hr";
var useToolbarSeparator = createHook(
  function useToolbarSeparator2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useToolbarContext();
    store = store || context;
    props = useCompositeSeparator(__spreadValues({ store }, props));
    return props;
  }
);
var ToolbarSeparator = forwardRef(function ToolbarSeparator2(props) {
  const htmlProps = useToolbarSeparator(props);
  return createElement(TagName, htmlProps);
});
export {
  ToolbarSeparator,
  useToolbarSeparator
};
